export enum DefectStatus {
  NONE = 0,
  OPEN = 1,
  IN_PROGRESS = 2,
  APPROVED = 3,
  REJECTED = 4,
}
